import i18n from './config';
import isEmpty from 'lodash/isEmpty';
import { sprintf } from 'sprintf-js';

/**
 *
 * @param {String} key
 * @param {String} secondaryString
 * @param {Dict} obj for interpolation, key value pair of the value which need to be replaced
 * @returns
 */
export const _lt = (key, ...values) => {
  if (isEmpty(key)) return key;

  if (i18n.exists(key)) {
    return i18n.t(key, ...values);
  } else {
    return sprintf(key, ...values) || '';
  }
};
